{
  "common": {
    "admin_settings": "Beheerinstellingen",
    "back": "← Terug",
    "delete": "Verwijderen",
    "edit": "Bewerken",
    "cancel": "Annuleren",
    "select": "Selecteren",
    "close": "Sluiten",
    "dismiss": "Sluiten",
    "scroll_left": "Naar links scrollen",
    "scroll_right": "Naar rechts scrollen"
  },
  "language": {
    "switcher_label": "Taal"
  },
  "wine_color": {
    "red": "Rood",
    "white": "Wit",
    "rose": "Rosé",
    "orange": "Oranje",
    "unknown": "Wijn"
  },
  "wine_style": {
    "sparkling": "Mousserend",
    "sweet": "Zoet",
    "fortified": "Versterkt"
  },
  "display_category": {
    "sparkling": "Mousserend",
    "white": "Wit",
    "orange": "Oranje",
    "rose": "Rosé",
    "red": "Rood",
    "dessert": "Dessert"
  },
  "cuisine": {
    "italian": "Italiaans",
    "french": "Frans",
    "japanese": "Japans",
    "chinese": "Chinees",
    "middle_eastern": "Midden-Oosters"
  },
  "course": {
    "starter": "Voorgerecht",
    "main": "Hoofdgerecht",
    "dessert": "Dessert"
  },
  "dietary_tag": {
    "vegetarian": "Vegetarisch",
    "vegan": "Veganistisch",
    "gluten_free": "Glutenvrij"
  },
  "taste_axis": {
    "taste_sweetness": "Zoetheid",
    "taste_acidity": "Zuurgraad",
    "taste_saltiness": "Zoutigheid",
    "taste_bitterness": "Bitterheid",
    "taste_umami": "Umami",
    "taste_richness": "Rijkheid",
    "taste_spice_heat": "Pittigheid"
  },
  "wine_filters": {
    "sommelier_picks": "Keuzes van de sommelier",
    "sommelier_picks_singular": "Keuze van de sommelier",
    "type": "Type",
    "price_view": "Prijsweergave",
    "by_bottle": "Per fles",
    "by_glass": "Per glas",
    "max_price": "Max. prijs",
    "region": "Regio",
    "bottle_size": "Flesformaat"
  },
  "wine_card": {
    "bottle": "Fles",
    "glass": "Glas"
  },
  "dish_card": {
    "chefs_special": "Chef's special",
    "plate": "Gerecht"
  },
  "dish_filters": {
    "chefs_choice": "Keuze van de chef",
    "cuisine": "Keuken",
    "course": "Gang",
    "dietary": "Dieet",
    "delete_all": "Alles verwijderen",
    "dish_count_one": "{{count}} gerecht",
    "dish_count_other": "{{count}} gerechten"
  },
  "home": {
    "page_title": "Wijnkaart",
    "tab_drinks": "Dranken",
    "tab_dishes": "Gerechten",
    "map_view": "Kaartweergave",
    "wine_count_one": "{{count}} wijn",
    "wine_count_other": "{{count}} wijnen",
    "dish_count_one": "{{count}} gerecht",
    "dish_count_other": "{{count}} gerechten",
    "no_wines_match": "Geen wijnen komen overeen met deze filters.",
    "no_dishes_yet": "Nog geen gerechten op de kaart.",
    "no_dishes_match": "Geen gerechten komen overeen met deze filters."
  },
  "map": {
    "page_title": "Wijnkaart op de kaart | Perfect Pairings",
    "map_view_title": "Kaartweergave",
    "wine_selection": "Wijnselectie",
    "our_cellar": "Onze kelder",
    "wines_lowercase": "wijnen",
    "full_view": "Volledige weergave",
    "sommelier_picks_only": "Alleen keuzes van de sommelier",
    "max_price": "Max. prijs",
    "click_pin_to_filter": "Klik op een pin op de kaart om te filteren",
    "show_less": "Minder tonen",
    "more_regions_one": "+{{count}} regio meer",
    "more_regions_other": "+{{count}} regio's meer",
    "no_wines_in_view": "Geen wijnen in de huidige kaartweergave.",
    "pan_or_zoom_out": "Verschuif of zoom uit om meer locaties te tonen.",
    "no_wines_match_selection": "Geen wijnen komen overeen met de huidige selectie.",
    "zoom_out": "Uitzoomen",
    "show_details": "Details tonen",
    "winery_fallback": "Wijnhuis"
  },
  "wine_show": {
    "page_title": "{{name}} | Wijnkaart | Perfect Pairings",
    "established": "Opgericht {{year}}",
    "sommelier_choice_line1": "KEUZE VAN DE",
    "sommelier_choice_line2": "SOMMELIER",
    "tasting_notes": "Proefnotities",
    "per_glass": "Per glas",
    "per_bottle": "Per fles",
    "vintage": "Jaargang",
    "origin": "Herkomst",
    "grape_variety": "Druivenras",
    "tasting_profile": "Smaakprofiel",
    "acidity": "Zuurgraad",
    "body": "Body",
    "tannin": "Tannine",
    "sweetness": "Zoetheid",
    "paired_selection": "Bijpassende selectie",
    "no_pairings_yet": "Nog geen bijpassende gerechten beschikbaar voor deze wijn.",
    "pairing_dish_fallback": "Bijpassend gerecht",
    "pairing_tag": "PAIRING",
    "untitled": "Naamloos",
    "winery_location": "Locatie wijnhuis",
    "estate_size": "Omvang landgoed",
    "founded": "Opgericht",
    "about_winery": "Over het wijnhuis",
    "winery_fallback": "Wijnhuis",
    "highlight_fallback": "Hoogtepunt"
  },
  "dish_show": {
    "page_title": "{{title}} | Perfect Pairings",
    "chefs_special_line1": "CHEF'S",
    "chefs_special_line2": "SPECIAL",
    "sommelier_pick_line1": "KEUZE VAN DE",
    "sommelier_pick_line2": "SOMMELIER",
    "price": "Prijs",
    "taste_profile": "Smaakprofiel",
    "wine_count_one": "{{count}} wijn",
    "wine_count_other": "{{count}} wijnen",
    "no_pairings_yet": "Nog geen bijpassende wijnen beschikbaar voor dit gerecht.",
    "pairing_wine_fallback": "Bijpassende wijn",
    "ingredients": "Ingrediënten"
  },
  "landing": {
    "meta_title": "Perfect Pairings — De wijnkaart heruitgevonden",
    "meta_description": "Een interactieve, kaartgedreven digitale wijnervaring voor fine dining restaurants.",
    "sign_in": "Inloggen",
    "book_demo": "Demo aanvragen",
    "hero": {
      "eyebrow": "Nu beschikbaar · Gratis proefperiode",
      "title_line1": "De wijnkaart",
      "title_line2": "heruitgevonden",
      "subtitle": "Een interactieve, kaartgedreven digitale wijnervaring voor fine dining restaurants. Til je kelder naar een hoger niveau. Inspireer je gasten. Verkoop meer wijn.",
      "start_trial": "Start je gratis proefperiode",
      "see_how": "Bekijk hoe het werkt",
      "scroll_aria": "Scroll naar hoe het werkt"
    },
    "why": {
      "label": "Waarom restaurants voor ons kiezen",
      "title": "Waarom Perfect Pairings",
      "subtitle": "Alles wat je nodig hebt om je kelder met vertrouwen te presenteren — van eerste upload tot het glas van je gast."
    },
    "features": {
      "discover": {
        "kicker": "Ontdek",
        "title": "Interactieve wijnkaart",
        "body": "Leid je gasten langs wijnregio's met een prachtige interactieve kaart — een simpele keuze wordt een reis."
      },
      "control": {
        "kicker": "Beheer",
        "title": "Moeiteloos beheer",
        "body": "Upload, bewerk en cureer je hele wijncollectie vanuit één elegant dashboard. Wijzigingen zijn direct live."
      },
      "enrich": {
        "kicker": "Verrijk",
        "title": "Digitale sommelier",
        "body": "Elke wijn wordt automatisch verrijkt met smaakprofielen, wijnhuisverhalen en expertnotities — zonder handmatig werk."
      }
    },
    "workflow": {
      "label": "Jouw werkwijze",
      "title": "Alles wat jouw kelder verdient",
      "subtitle": "Een duidelijk pad van kaart naar gast — gebouwd voor drukke eetzalen en nauwgezette sommeliers."
    },
    "steps": {
      "step_label": "Stap {{number}}",
      "upload": {
        "title": "Upload je wijnkaart",
        "body": "CSV, Excel of handmatige invoer. Elke wijn wordt automatisch verrijkt met beschrijvingen, proefnotities en wijnhuisverhalen.",
        "extra": "CSV, Excel, PDF of afbeelding — AI haalt de wijnen er automatisch uit",
        "image_alt": "Wijnkaart en proefervaring"
      },
      "share": {
        "title": "Deel met je gasten",
        "body": "Eén link of QR-code. Gasten verkennen je wijnen op een interactieve wereldkaart, vanaf hun tafel.",
        "image_alt": "Wijngaardlandschap"
      },
      "customise": {
        "title": "Personaliseer je kelder",
        "body": "Stel keuzes van de sommelier in, voeg foto's toe, verfijn smaakprofielen. Jouw kaart, jouw curatie.",
        "image_alt": "Wijnkelder"
      }
    },
    "testimonials_section": {
      "label": "Vertrouwd door teams",
      "title": "Vroege gebruikers"
    },
    "testimonials": {
      "maison_doree": {
        "quote": "Onze gasten besteden nu twee keer zoveel tijd aan het verkennen van de wijnkaart. Het heeft de manier waarop we flessen verkopen veranderd.",
        "role": "F&B Director, Maison Dorée"
      },
      "osteria_fina": {
        "quote": "De kaartweergave is buitengewoon. Het brengt ons team en de gast al in gesprek voordat er een woord is gezegd.",
        "role": "Hoofdsommelier, Osteria Fina"
      }
    },
    "cta": {
      "title": "Begin vandaag nog",
      "body1": "We nemen momenteel een select aantal restaurants aan boord. Boek een persoonlijke demo en we bouwen samen je wijnkaart op — live, in minder dan een uur.",
      "body2": "Doe mee aan ons proefprogramma en breng een nieuwe dimensie aan je wijnservice. Geen risico, geen verplichting — gewoon een betere wijnervaring voor je gasten.",
      "contact_us": "Neem contact op",
      "footer_line": "Stel je profiel in en begin met het bouwen van je digitale wijnkaart"
    },
    "footer": {
      "copyright": "© 2026 Perfect Pairings. Alle rechten voorbehouden."
    }
  },
  "manager_nav": {
    "restaurant_admin": "Restaurantbeheer",
    "manage_wines": "Wijnen beheren",
    "manage_dishes": "Gerechten beheren",
    "start_pairing": "Start pairing",
    "customer_view": "Gastweergave",
    "log_out": "Uitloggen"
  },
  "manager_common": {
    "your_restaurant": "Jouw restaurant",
    "logo_alt": "Logo van {{name}}"
  },
  "restaurant_admin": {
    "page_title": "{{name}} beheer | Wijnkaart | Perfect Pairings",
    "restaurant_fallback": "Restaurant",
    "eyebrow": "Restaurantbeheer",
    "public_menu_link": "Publieke menulink",
    "public_menu_link_description": "Deel deze met gasten, of print 'm als QR-code voor op tafel — geen inloggen nodig.",
    "copied": "Gekopieerd!",
    "copy_link": "Link kopiëren",
    "upload_logo": "Logo uploaden",
    "logo_hint": "PNG, JPG tot 5MB",
    "restaurant_name": "Restaurantnaam",
    "restaurant_name_placeholder": "bijv. La Maison du Vin",
    "description": "Omschrijving",
    "description_placeholder": "Vertel gasten over je restaurant en wijnfilosofie...",
    "language": "Taal",
    "language_hint": "Stuurt elke gastpagina en je eigen managerschermen. Gasten kunnen zelf nog wel van taal wisselen op de publieke kaart.",
    "creating": "Bezig met aanmaken...",
    "saving": "Bezig met opslaan...",
    "create_restaurant": "Restaurant aanmaken",
    "save_changes": "Wijzigingen opslaan",
    "sections": {
      "general": {
        "title": "Algemene instellingen",
        "subtitle": "Restaurantnaam, omschrijving en contactgegevens"
      },
      "guided_selling": {
        "title": "Guided selling",
        "subtitle": "Help je bedieningsteam de juiste wijn bij elk gerecht te kiezen"
      },
      "placeholder_images": {
        "title": "Placeholder-afbeeldingen",
        "subtitle": "Standaardafbeeldingen die getoond worden zonder eigen foto"
      },
      "subscriptions": {
        "title": "Abonnementen",
        "subtitle": "Beheer actieve modules en add-ons"
      }
    },
    "guided_selling": {
      "intro": "Guided selling rangschikt wijn-gerechtcombinaties puur op smaak -- prijs speelt in die stap geen rol. Deze dial bepaalt alleen hoeveel de ladder daarna, per prijsband, marge mag laten meewegen tussen wijnen die al even goed passen.",
      "open_link": "Open guided selling"
    },
    "margin_depth": {
      "pure_taste": "Puur smaak",
      "pure_taste_description": "De beste smaakmatch wint altijd.",
      "light_steer": "Licht sturen",
      "light_steer_description": "Marge beslist bij een gelijke smaakscore.",
      "active_steer": "Actief sturen",
      "active_steer_description": "Bewust wat smaak inruilen voor marge."
    },
    "placeholders": {
      "winery_banner": "Wijnhuis-banner",
      "uploaded": "Geüpload",
      "system_default": "Systeemstandaard",
      "custom": "Aangepast",
      "landscape_hint": "Liggende panoramafoto",
      "portrait_hint": "Staande flesfoto",
      "no_image": "Geen afbeelding",
      "uploading": "Bezig met uploaden...",
      "replace_image": "Afbeelding vervangen",
      "upload_image": "Afbeelding uploaden"
    },
    "subscriptions": {
      "no_modules": "Er zijn momenteel geen modules beschikbaar. Vraag je beheerder om pakketten te publiceren.",
      "monthly_price": "Maandelijks: {{price}}",
      "yearly_price": "Jaarlijks: {{price}}",
      "yearly_savings": "Bespaar ongeveer {{percent}}% per jaar",
      "request_in_progress": "Aanvraag in behandeling",
      "active": "Actief",
      "billing_fallback": "facturatie",
      "date_range": "{{start}} tot {{end}}",
      "cancelling": "Bezig met opzeggen…",
      "cancel_subscription": "Abonnement opzeggen",
      "enable_hint": "Zet deze module aan om een facturatiecyclus te kiezen en te abonneren.",
      "modal_title": "Facturatie voor {{title}}",
      "modal_subtitle": "Kies hoe je gefactureerd wilt worden.",
      "yearly": "Jaarlijks",
      "monthly": "Maandelijks",
      "yearly_savings_full": "Bespaar ongeveer {{percent}}% t.o.v. maandelijks over een heel jaar.",
      "due_today": "Nu verschuldigd",
      "compare_at": "Vergelijk met {{price}} bij maandelijkse facturatie over 12 maanden",
      "start_date": "Startdatum",
      "end_date": "Einddatum",
      "close": "Sluiten",
      "subscribing": "Bezig met abonneren…",
      "subscribe": "Abonneren",
      "cancel_confirm_title": "Abonnement opzeggen?",
      "cancel_confirm_body": "Weet je zeker dat je dit abonnement wilt opzeggen? Je verliest direct toegang tot de modulefuncties.",
      "keep_it": "Nee, behouden",
      "confirm_cancel": "Ja, opzeggen"
    }
  },
  "guided_selling": {
    "page_title": "{{title}} | Guided Selling - Perfect Pairings",
    "index_page_title": "Guided Selling | Perfect Pairings",
    "eyebrow": "Guided Selling",
    "dish_fallback": "Gerecht",
    "dishes_stat_label": "Gerechten",
    "pick_a_dish": "Kies een gerecht",
    "no_dishes_yet": "Nog geen gerechten op de kaart van dit restaurant.",
    "no_dishes_match": "Geen gerechten gevonden voor deze zoekopdracht en filters.",
    "search_placeholder": "Zoek gerechten…",
    "all_courses": "Alles",
    "more_filters": "Meer filters",
    "dishes_matching_one": "{{count}} van {{total}} gerecht",
    "dishes_matching_other": "{{count}} van {{total}} gerechten",
    "recently_picked": "Recent gekozen",
    "just_now": "zojuist",
    "minutes_ago_one": "{{count}} min geleden",
    "minutes_ago_other": "{{count}} min geleden",
    "hours_ago_one": "{{count}}u geleden",
    "hours_ago_other": "{{count}}u geleden",
    "days_ago_one": "{{count}}d geleden",
    "days_ago_other": "{{count}}d geleden",
    "wines_scored_one": "{{count}} wijn beoordeeld",
    "wines_scored_other": "{{count}} wijnen beoordeeld",
    "not_available": "N.v.t.",
    "upsell_why_toggle": "Waarom?",
    "bottle_nudge": "Vanaf twee glazen per persoon is de fles voordeliger.",
    "house_pick": "Keuze van het huis",
    "set_house_pick_prompt": "Stel een keuze van het huis in bij de gerechtinstellingen",
    "suggested_pairings": "Voorgestelde pairings",
    "generating": "Suggesties voor dit gerecht worden gegenereerd — kom straks terug.",
    "no_serving_format_glass": "Deze wijnkaart heeft nog geen wijnen per glas.",
    "no_serving_format_bottle": "Deze wijnkaart heeft nog geen wijnen per fles.",
    "manage_wines_link": "Wijnen beheren",
    "no_suitable_pairings": "Nog geen passende wijn-pairings gevonden voor dit gerecht in deze weergave."
  },
  "wine_form": {
    "page_title": "{{title}} | Wijnkaart | Perfect Pairings",
    "wine_catalog": "Wijncatalogus",
    "back_to_wines": "← Terug naar wijnen",
    "add_wine": "Wijn toevoegen",
    "edit_wine": "{{name}} bewerken",
    "save_wine": "Wijn opslaan",
    "wine_fallback": "Wijn",
    "enrich_error": "Kon deze wijn niet verrijken.",
    "enriching": "Bezig met verrijken…",
    "enrich_product": "✨ Product verrijken",
    "saving": "Bezig met opslaan…",
    "section_identity": "Identiteit & herkomst",
    "section_pricing": "Prijs & beschikbaarheid",
    "section_tasting": "Smaak & karakter",
    "section_profile": "Smaakprofiel (1-5)",
    "section_producer": "Producentgegevens",
    "wine_name": "Wijnnaam *",
    "color": "Kleur *",
    "select_color": "Kies een kleur…",
    "style": "Stijl",
    "style_none": "Geen",
    "grape_variety": "Druivenras",
    "winery": "Wijnhuis",
    "vintage": "Jaargang",
    "region": "Regio",
    "country": "Land",
    "price_per_bottle": "Prijs per fles (€)",
    "price_per_glass": "Prijs per glas (€)",
    "cost_per_bottle": "Kostprijs per fles (€)",
    "cost_per_glass": "Kostprijs per glas (€)",
    "not_tracked": "Niet bijgehouden",
    "available_in_size": "Beschikbaar in formaat",
    "description": "Omschrijving",
    "tasting_notes": "Proefnotities (komma-gescheiden)",
    "tasting_notes_placeholder": "Donker fruit, ceder, tabak, viooltje",
    "winery_founded": "Wijnhuis opgericht",
    "winery_founded_placeholder": "bijv. 1855",
    "estate_size": "Omvang landgoed",
    "estate_size_placeholder": "bijv. 106 hectare",
    "winery_location": "Locatie wijnhuis",
    "about_winery": "Over het wijnhuis",
    "latitude": "Breedtegraad",
    "longitude": "Lengtegraad",
    "drink_from": "Drinken vanaf",
    "drink_until": "Drinken tot",
    "bottle_placeholder": "Flesplaceholder",
    "winery_banner_placeholder": "Wijnhuis-bannerplaceholder",
    "remove_image": "Afbeelding verwijderen",
    "no_placeholder_set": "Geen placeholder ingesteld",
    "upload": "Uploaden"
  },
  "wine_index": {
    "page_title": "Wijnen beheren | Wijnkaart | Perfect Pairings",
    "eyebrow": "Wijnen beheren",
    "total_wines": "Totaal aantal wijnen",
    "cost_price_filled": "Kostprijs ingevuld",
    "cost_price_hint": "Nodig voor marge-gebaseerde pairing-suggesties",
    "hide_upload_panel": "Uploadpaneel verbergen",
    "upload_wines": "Wijnen uploaden",
    "upload_wine_list_file": "Wijnkaartbestand uploaden",
    "drop_wine_list_here": "Sleep je wijnkaart hierheen",
    "extract_hint": "We halen tot {{count}} wijnen per upload eruit voor beoordeling vóór import. CSV/Excel worden direct verwerkt; PDF en afbeeldingen gebruiken AI (naam per rij verplicht).",
    "choose_file": "Bestand kiezen",
    "selected_file": "Geselecteerd: {{name}}",
    "enrich_with_ai": "Verrijken met AI",
    "uploading": "Bezig met uploaden…",
    "upload_and_extract": "Upload & extraheer",
    "import_history": "Importgeschiedenis",
    "import_history_hint": "Status wordt automatisch bijgewerkt zolang je op deze pagina blijft.",
    "no_imports_yet": "Nog geen imports.",
    "extracted_count": "Geëxtraheerd: {{count}}",
    "invalid_count": "Ongeldig: {{count}}",
    "created_count": "Aangemaakt: {{count}}",
    "skipped_count": "Overgeslagen: {{count}}",
    "errors_count": "Fouten: {{count}}",
    "queued_at": "In wachtrij op: {{time}}",
    "started_at": "Gestart op: {{time}}",
    "finished_at": "Voltooid op: {{time}}",
    "enrichment_enriched": "Verrijking: {{count}} verrijkt",
    "enrichment_failed": ", {{count}} mislukt",
    "enrichment_in_progress": " — {{count}} nog bezig…",
    "could_not_retry_failed": "Kon mislukte rijen niet opnieuw proberen.",
    "retry_failed_rows_one": "Probeer {{count}} mislukte rij opnieuw",
    "retry_failed_rows_other": "Probeer {{count}} mislukte rijen opnieuw",
    "rows_truncated": "Alleen de eerste {{max}} wijnen zijn geëxtraheerd.",
    "rows_truncated_with_total": "Alleen de eerste {{max}} wijnen zijn geëxtraheerd ({{total}} gevonden in bestand).",
    "sample_row_errors": "Voorbeeld van rijfouten",
    "row_error": "Rij {{row}}: {{messages}}",
    "loading": "Bezig met laden…",
    "review_wines_one": "Beoordeel {{count}} wijn",
    "review_wines_other": "Beoordeel {{count}} wijnen",
    "download_invalid_rows_csv": "Download ongeldige rijen als CSV",
    "delete_run": "Run verwijderen",
    "imports_still_running": "Een of meer imports lopen nog. Klik op Vernieuwen voor de laatste status.",
    "wines_heading": "Wijnen ({{count}})",
    "wine_count_one": "{{count}} wijn",
    "wine_count_other": "{{count}} wijnen",
    "search_wines": "Zoek wijnen...",
    "all_types": "Alle types",
    "delete_selected": "Selectie verwijderen ({{count}})",
    "n_selected": "{{count}} geselecteerd",
    "no_wines_yet": "Nog geen wijnen. Voeg je eerste wijn toe of upload een kaart.",
    "no_wines_match": "Geen wijnen komen overeen met je huidige zoekopdracht/filter.",
    "pick_badge": "Keuze",
    "edit_wine_aria": "{{name}} bewerken",
    "delete_wine_aria": "{{name}} verwijderen",
    "details_wine_aria": "Details voor {{name}}",
    "description_and_notes": "Omschrijving & notities",
    "prev_page": "← Vorige",
    "next_page": "Volgende →",
    "page_of": "Pagina {{page}} / {{pages}} ({{count}} totaal)",
    "per_page": "Per pagina",
    "import_started": "Import gestart. Je krijgt bericht zodra het klaar is.",
    "confirm_delete_title": "Verwijdering bevestigen",
    "confirm_delete_body": "{{target}} verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "confirm_delete_button": "Verwijdering bevestigen",
    "deleting": "Bezig met verwijderen…",
    "could_not_load_review": "Kon wijnen voor beoordeling niet laden.",
    "all_wines_in_catalog_one": "{{count}} wijn in je catalogus",
    "all_wines_in_catalog_other": "{{count}} wijnen in je catalogus",
    "selected_wines_one": "{{count}} geselecteerde wijn",
    "selected_wines_other": "{{count}} geselecteerde wijnen"
  },
  "tag_input": {
    "remove_tag": "{{tag}} verwijderen"
  },
  "taste_slider": {
    "aria_label": "{{label}} {{score}} van de 5"
  },
  "dish_form": {
    "page_title": "{{title}} | Wijnkaart | Perfect Pairings",
    "dish_catalog": "Gerechtencatalogus",
    "back_to_dishes": "← Terug naar gerechten",
    "add_dish": "Gerecht toevoegen",
    "edit_dish": "{{title}} bewerken",
    "save_dish": "Gerecht opslaan",
    "dish_fallback": "Gerecht",
    "enrich_error": "Kon dit gerecht niet verrijken.",
    "section_identity": "Identiteit",
    "section_pricing": "Prijs",
    "dish_name": "Gerechtnaam *",
    "price": "Prijs (€)",
    "cost": "Kostprijs (€)",
    "description": "Omschrijving",
    "highlights": "Hoogtepunten",
    "chefs_special": "Chef's special",
    "ingredients": "Ingrediënten",
    "ingredient_placeholder": "Typ een ingrediënt, druk op Enter",
    "ingredient_placeholder_full": "bijv. kip, knoflook, tijm — druk na elk op Enter",
    "item_image": "Afbeelding",
    "item_image_hint": "Upload een afbeelding van hoge kwaliteit zodat dit gerecht opvalt in de catalogus.",
    "upload_image": "Afbeelding uploaden",
    "choose_file": "Bestand kiezen",
    "no_file_selected": "Geen bestand geselecteerd",
    "menu_item_fallback": "Gerecht",
    "no_image": "Geen afbeelding",
    "status": "Status",
    "status_active": "Actief",
    "status_inactive": "Inactief",
    "house_pick_hint": "De handmatige wijnaanbeveling van de sommelier voor dit gerecht, getoond boven de guided-selling-ladder.",
    "wine_to_feature": "Uit te lichten wijn",
    "no_house_pick": "— Geen keuze van het huis —",
    "why_optional": "Waarom (optioneel)",
    "house_pick_note_placeholder": "Zonder eigen tekst valt dit terug op de AI-uitleg voor deze wijn."
  },
  "dish_index": {
    "page_title": "Gerechten beheren | Wijnkaart | Perfect Pairings",
    "eyebrow": "Gerechten beheren",
    "total_dishes": "Totaal aantal gerechten",
    "upload_dishes": "Gerechten uploaden",
    "upload_dish_list_file": "Gerechtenlijst uploaden",
    "drop_menu_here": "Sleep je menu hierheen",
    "extract_hint": "We halen tot {{count}} gerechten per upload eruit voor beoordeling vóór import. CSV/Excel worden direct verwerkt; PDF en afbeeldingen gebruiken AI (naam per rij verplicht).",
    "rows_truncated": "Alleen de eerste {{max}} gerechten zijn geëxtraheerd.",
    "rows_truncated_with_total": "Alleen de eerste {{max}} gerechten zijn geëxtraheerd ({{total}} gevonden in bestand).",
    "review_dishes_one": "Beoordeel {{count}} gerecht",
    "review_dishes_other": "Beoordeel {{count}} gerechten",
    "imports_still_running": "Een of meer imports lopen nog. Status wordt automatisch ververst.",
    "dishes_heading": "Gerechten ({{count}})",
    "dishes_heading_count_one": "{{count}} gerecht",
    "dishes_heading_count_other": "{{count}} gerechten",
    "search_dishes": "Zoek gerechten...",
    "all_courses": "Alle gangen",
    "no_description_yet": "Nog geen omschrijving.",
    "no_dishes_yet": "Nog geen gerechten. Voeg je eerste gerecht toe of upload een menu.",
    "no_dishes_match": "Geen gerechten komen overeen met je huidige zoekopdracht/filter.",
    "could_not_load_review": "Kon gerechten voor beoordeling niet laden.",
    "all_dishes_in_catalog_one": "alle {{count}} gerecht",
    "all_dishes_in_catalog_other": "alle {{count}} gerechten in je catalogus"
  },
  "import_review": {
    "wine_name_blank": "Wijnnaam mag niet leeg zijn",
    "winery_blank": "Wijnhuis mag niet leeg zijn",
    "color_missing": "Kleur staat niet in de lijst",
    "dish_name_blank": "Gerechtnaam mag niet leeg zijn",
    "untitled_wine": "Naamloze wijn",
    "untitled_dish": "Naamloos gerecht",
    "invalid": "Ongeldig",
    "invalid_with_count": "Ongeldig ({{count}})",
    "new_badge": "Nieuw",
    "already_on_card": "Al op de kaart",
    "price_changed_title": "Prijs {{size}} gewijzigd",
    "price_changed": "Prijs gewijzigd",
    "remove_wine": "{{name}} verwijderen",
    "remove_dish": "{{name}} verwijderen",
    "wine_count_one": "{{count}} wijn",
    "wine_count_other": "{{count}} wijnen",
    "dish_count_one": "{{count}} gerecht",
    "dish_count_other": "{{count}} gerechten",
    "gone": "Verdwenen",
    "keep": "Behouden",
    "remove": "Verwijderen",
    "add": "Toevoegen",
    "skip": "Overslaan",
    "update": "Bijwerken",
    "update_prices": "Prijzen bijwerken",
    "removed_when_finished": "Wordt van je kaart verwijderd zodra de import klaar is.",
    "removed_from_menu_when_finished": "Wordt van je menu verwijderd zodra de import klaar is.",
    "nothing_selected": "Niets geselecteerd om te importeren.",
    "import_failed": "Import mislukt.",
    "network_error_wines": "Netwerkfout tijdens het importeren van wijnen.",
    "network_error_dishes": "Netwerkfout tijdens het importeren van gerechten.",
    "wine_validation_title": "Wijnkaart valideren",
    "wine_validation_subtitle": "Bekijk, categoriseer en valideer geëxtraheerde wijnen van de kaart.",
    "menu_validation_title": "Menu valideren",
    "menu_validation_subtitle": "Bekijk, categoriseer en valideer geëxtraheerde gerechten van je menu.",
    "showing_first": "· Eerste {{count}} getoond",
    "showing_first_of_total": "· Eerste {{count}} van {{total}} gevonden getoond",
    "extracted_wines": "Geëxtraheerde wijnen",
    "extracted_dishes": "Geëxtraheerde gerechten",
    "all": "Alle",
    "no_invalid_wines": "Geen ongeldige wijnen in deze lijst.",
    "no_wines_to_review": "Geen wijnen om te beoordelen.",
    "no_invalid_dishes": "Geen ongeldige gerechten in deze lijst.",
    "no_dishes_to_review": "Geen gerechten om te beoordelen.",
    "edit_wine_details": "Wijngegevens bewerken",
    "edit_dish_details": "Gerechtgegevens bewerken",
    "enrich_with_ai": "Verrijken met AI",
    "select_wine_to_edit": "Selecteer een wijn uit de lijst om de gegevens te bewerken.",
    "select_dish_to_edit": "Selecteer een gerecht uit de lijst om de gegevens te bewerken.",
    "wines_ready_to_import_one": "{{count}} wijn klaar om te importeren",
    "wines_ready_to_import_other": "{{count}} wijnen klaar om te importeren",
    "dishes_ready_to_import_one": "{{count}} gerecht klaar om te importeren",
    "dishes_ready_to_import_other": "{{count}} gerechten klaar om te importeren",
    "marked_invalid_suffix": " · {{count}} als ongeldig gemarkeerd",
    "to_remove_suffix": " · {{count}} te verwijderen van je kaart",
    "to_remove_from_menu_suffix": " · {{count}} te verwijderen van je menu",
    "starting_import": "Import wordt gestart…",
    "finalize_wine_import": "Wijnimport afronden",
    "finalize_menu_import": "Menu-import afronden"
  },
  "location_edit": {
    "create_page_title": "Maak je restaurant aan | Perfect Pairings",
    "create_heading": "Maak je restaurant aan",
    "edit_heading": "Restaurantgegevens bewerken",
    "back_to_restaurant_admin": "← Terug naar restaurantbeheer",
    "digital_sommelier": "Digitale sommelier"
  },
  "subscription_page": {
    "page_title": "Moduleabonnementen | Perfect Pairings",
    "billing": "Facturatie",
    "module_subscriptions": "Moduleabonnementen",
    "access_required": "Toegang vereist",
    "access_required_body": "Je hebt momenteel geen toegang tot deze module. Vraag een abonnement aan voor deze module.",
    "sending_request": "Verzoek wordt verstuurd…",
    "send_pending_invite": "Verzoek versturen"
  },
  "wine_tile_view": {
    "page_title": "Wijnen | Wijnkaart | Perfect Pairings",
    "search_placeholder": "Begin met typen: Rioja, Chardonnay, Sommelier...",
    "search": "Zoeken",
    "reset": "Reset",
    "filtered_count": "{{shown}} van {{total}} op deze pagina ({{count}} totaal)",
    "page_of": "Pagina {{page}} / {{pages}}",
    "no_wines_on_page_match": "Geen wijnen op deze pagina komen overeen met je filters.",
    "no_wines_match_search": "Geen wijnen komen overeen met je zoekopdracht.",
    "clear_filters": "Filters wissen"
  },
  "dish_tile_view": {
    "page_title": "Gerechten | Wijnkaart | Perfect Pairings",
    "search_placeholder": "Zoek menu-items...",
    "no_menu_items_match": "Geen menu-items komen overeen met je filters."
  }
}
